<template>
    <div class="section-box">
        <el-tabs v-model="form.seaType" type="card" class="customer-tabs-mg" @tab-click="handleSearch">
            <el-tab-pane 
                v-for="(item,index) in seasType"
                :label="item.value"
                :name="item.key+''"
                :key="index"
            ></el-tab-pane>
        </el-tabs>
        <div class="customer-list">
            <div class="next-button" v-if="!(typeof(actionData.customerghkh_add) != 'undefined'&&!actionData.customerghkh_add)">
                <el-button size="small" type="primary" icon="el-icon-plus" @click="handleOpen">添加</el-button>
            </div>
            <el-row class="customer-row-bg">
                <el-col :span="12" style="text-align: left;">
                    <el-form :inline="true" label-width="80px" label-position="left">
                        <el-form-item label="分类：" size="medium">
                                <el-button size="mini" :class="{'selected':form.custPageType == 0}" @click="handleSearchType(0)">全部</el-button>
                                <el-button size="mini" style="margin-left: 25px;" :class="{'selected':form.custPageType == 1}" @click="handleSearchType(1)">未注册</el-button>
                                <el-button size="mini" style="margin-left: 25px;" :class="{'selected':form.custPageType == 2}" @click="handleSearchType(2)">已注册</el-button>
                                <el-button size="mini" style="margin-left: 25px;" :class="{'selected':form.custPageType == 3}" @click="handleSearchType(3)">已签订合同</el-button>
                                <el-button size="mini" style="margin-left: 25px;" :class="{'selected':form.custPageType == 4}" @click="handleSearchType(4)">已成单</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>
                <el-col :span="12" style="text-align: right;">
                    <el-button size="medium" type="primary" @click="handleSearch">查询</el-button>
                    <el-button size="medium" type="success" @click="handleReset">重置</el-button>
                </el-col>
            </el-row>
        </div>

         <!-- 列表 -->
        <el-table
            :stripe="true"
            :data="tableData"
            style="width: 100%;margin-top: 20px;"
            height="590"
            border
            v-loading="listLoading" 
            >
            <!-- eslint-disable  -->
            <el-table-column label="企业名称">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.companyname" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span class="linkInfo" v-if="scope.row.companyname" @click="linkCustomerInfoFun(scope.row.companyid,scope.row.custId)">{{scope.row.companyname}}</span>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="企业ID">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.companyid" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.companyid || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="企业类型">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" 
                            placeholder="请选择" 
                            v-model="form.rolescode" 
                            style="width: 100%;"
                        >
                            <el-option
                                v-for="(item,index) in companyRolesList"
                                :value="item.rolescode" 
                                :label="item.rolesname"
                                :key="index"
                            ></el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.rolesname || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="企业账号">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.account" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.account || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="地区">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="region" placeholder="请选择" @click.native="isRegionShow"/>
                    </template>
                    <template slot-scope="scope">
                        <span v-if="scope.row.provinceName">{{scope.row.provinceName}}{{scope.row.cityName}}</span>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="固定电话">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.phone" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.phone || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
        </el-table>
        <div style="margin: 10px;overflow: hidden">
            <div style="float: right;" v-show="tableData.length">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="form.pageNum"
                    :page-sizes="[10, 20, 50, 100, 200]"
                    :page-size="form.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </div>
        <el-dialog 
            :visible.sync="areaShow" 
            title="地区" 
            width="34%" 
            ref="dialog"
            append-to-body
        >
            <el-form ref="area" label-width="60px" >
                <el-form-item label="地址：">
                    <el-select 
                        size="medium" 
                        value-key="aid"
                        v-model="regionForm.ProvinceId"
                        placeholder="省"
                        filterable
                        clearable
                        style="width: 48%;margin-right: 10px;"
                        @change="ProvinceIdFun"
                    >
                        <el-option 
                            v-for="(item, index) in ProvinceIdList" 
                            :value="item" 
                            :label="item.areaname" 
                            :key="index"
                        ></el-option>
                    </el-select>
                    <el-select 
                        size="medium" 
                        value-key="aid" 
                        v-model="regionForm.CityId" 
                        placeholder="市" 
                        filterable 
                        clearable 
                        style="width: 48%;margin-right: 10px;" 
                    >
                        <el-option 
                            v-for="(item, index) in CityIdList" 
                            :value="item" 
                            :label="item.areaname" 
                            :key="index"
                        ></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitAddressFun">确 定</el-button>
            </span>
        </el-dialog>
        <AddDialog ref="addCustomer" @onSubmit="confirmSeasAdd"/>
    </div>
</template>
<script>
    import AddDialog from './index/addCustomerDialog'
    import {
        seasTypeList,   //公海类型
        seasList,       //列表
        seasAdd,        //添加
    } from "@/service/customerInformation";
    import {
        companyRoles,       //企业类型
        optionsArea,        //省市区
    } from "@/service/area";
    import { 
        getActionData
    } from '@/utils/store'
    export default {
        components: {
            AddDialog
        },
        data() {
            return {
                actionData: JSON.parse(getActionData()),      //功能按钮每个页面必须用
                seasType: [],       //公海类型
                listLoading: false,
                form: {
                    pageNum: 1,
                    pageSize: 10,

                    companyname: '',        //企业名称
                    companyid: '',          //企业id
                    rolescode: '',          //企业类型Code
                    account: '',            //企业账户（名称）


                    phone: '',              //手机号

                    custPageType: 0,        //客户状态分类(0=全部，1=未注册，2=已注册，3=已签订合同，4=已成单) ,
                    seaType: '1',           //公海类型（1=销售公海，2=外部销售公海，3=对接公海，4=客户成功部公海）
                },
                searchData:{},
                oraginForm:{},
                total: 0,                       //总条数

                
                tableData:[],
                companyRolesList: [],           //企业类型

                // 地区
                areaShow: false,
                region: '', 

                regionForm: {
                    ProvinceId: '', //省
                    CityId: '', //市
                },

                ProvinceIdList: [],
                CityIdList: [],
            };
        },
        activated(){
            this.handleSearch()
        },
        created() {
            this.oraginForm = JSON.parse(JSON.stringify(this.form))
            this.tableData = [];
            this.getSeasTypeList();
            this.getCompanyRoles();
        },
        methods: {
            // 获取公海类型
            getSeasTypeList(){
                seasTypeList().then(res=>{
                    this.seasType = res.Data.slice(0,-1)
                })
            },
            //企业类型
            getCompanyRoles(){
                companyRoles().then(res=> {
                    this.companyRolesList = res.Data
                })
            },
            // 分类
            handleSearchType(type){
                this.form.custPageType = type
                this.handleSearch()
            },
            // 查询
            handleSearch() {
                this.searchData = Object.assign({}, this.form)
                this.handleCurrentChange(1)
            },
            // 重置
            handleReset() {
                this.regionForm = {
                    ProvinceId: '', //省
                    CityId: '', //市
                    XianId: '', //区
                }
                this.region = ''
                this.form = JSON.parse(JSON.stringify(this.oraginForm))
                this.handleSearch()
            },
            handleSizeChange(val) {
                if (this.listLoading) return
                this.form.pageNum = 1
                this.form.pageSize = val
                this.searchData.pageNum = 1
                this.searchData.pageSize = val
                this.GetSeasList()
            },
            handleCurrentChange(val) {
                if (this.listLoading) return
                this.form.pageNum = val
                this.searchData.pageNum = val
                this.GetSeasList()
            },
            //获取公海客户列表
            async GetSeasList(){
                this.listLoading = true
                let data = JSON.parse(JSON.stringify(this.searchData))
                data.rational = true
                data.seaType = Number(data.seaType)
                !data.companyname && delete data.companyname
                !data.companyid && delete data.companyid
                !data.rolescode && delete data.rolescode
                !data.account && delete data.account
                !data.phone && delete data.phone
                data.provinceId = this.regionForm.ProvinceId.aid
                data.cityId = this.regionForm.CityId.aid
                !data.provinceId && delete data.provinceId
                !data.cityId && delete data.cityId
                let res = await seasList(data)
                this.listLoading = false
                if(res.Result != 1) {
                    return this.$message.error('获取失败请联系开发人员')
                }
                this.tableData = res.Data.datas
                this.total = res.Data.total
            },
            // 点击新增
            handleOpen(){
                this.$refs.addCustomer.open()
            },
            // 添加按钮
            confirmSeasAdd(val) {
                seasAdd(val).then(res=> {
                    if(res.Result != 1) {
                        return this.$message.error(res.Message)
                    }
                    this.$message.success('添加成功！')
                    this.$refs.addCustomer.editorClose()
                    this.GetSeasList();
                })
            },

            // 地区
            isRegionShow(){
                this.areaShow = true
                this.$nextTick(()=>{
                    this.getAreaDataByParentFun(0,1)
                })
            },
            // 点击省份
            ProvinceIdFun(){
                this.getAreaDataByParentFun(this.regionForm.ProvinceId.aid,2)
                this.regionForm.CityId = {aid : '',areaname: ''}
            },
            // 点击地址确定
            submitAddressFun(){
                if(this.regionForm.CityId.areaname) {
                    this.region = this.regionForm.ProvinceId.areaname + this.regionForm.CityId.areaname
                }else{
                    this.region = this.regionForm.ProvinceId.areaname 
                }
                this.areaShow = false
            },

            //获取地址
            async getAreaDataByParentFun(id,hier){
                let data = {
                    aid: id,
                    areaType: hier
                }
                let res = await optionsArea(data)
                    switch(hier){
                        case 1:
                            this.ProvinceIdList = res.Data
                            // console.log('省')
                            break;
                        default:
                            this.CityIdList = res.Data
                            // console.log('市')
                    }
            },
            // 跳转到客户信息
            linkCustomerInfoFun(id,custId) {
                if(!custId) custId = 0
                this.$router.push('/customer/customerInfo?companyId='+ id +'&custId='+custId)
            },
        }
    };
</script>
<style  lang="scss">
    .customer-tabs-mg {
        .el-tabs__header {
            margin: 0 0 15px !important;
        }
    }
    .customer-list {
        position: relative;
        .next-button {
            position: absolute;
            right: 0;
            top: -56px;
        }
    }
    .customer-row-bg {
        padding: 20px 14px;
        background-color: #f9fafc;
        display: flex;
        align-items: center;
        .el-form-item {
            margin-bottom: 0 !important;
        }
        .selected {
            color: #409EFF;
            border-color: #c6e2ff;
            background-color: #ecf5ff;
        }
    }
    .linkInfo {
        cursor: pointer;
        &:hover {
            color: #409EFF;
        }
    }
</style>